import { HOST } from "../constants";

export const getImageURL = (path) => {
    if (path) {
        if (Array.isArray(path)) {
            if (typeof path[0] === "object") {
                return URL.createObjectURL(path[0]);
            } else {
                return HOST + path[0];
            }
        } else if (typeof path === "object") {
            return URL.createObjectURL(path);
        } else if (path.includes("http")) {
            return path;
        } else {
            return HOST + path;
        }
    }
    return;
};
